import styled, { css } from 'styled-components';

import { mediaMixin, spaceMixin, Text } from '@zillow/constellation';

import { baseFontStyle } from '../../StyledComponents';

export const StyledHeading = styled(Text)`
    && {
        ${baseFontStyle}
        font-weight: 700;
        margin-bottom: ${spaceMixin('xs')};
        text-transform: uppercase;
    }
`;

export const StyledSubheading = styled(Text)`
    && {
        ${baseFontStyle}
        margin: ${spaceMixin('sm')} 0 ${spaceMixin('xs')};

        ${mediaMixin('lg', css`
            margin: ${spaceMixin('md')} 0 ${spaceMixin('sm')};
        `)}
    }
`;
